import {
  AgeGroup,
  Game,
  postGameByGameIdReport,
} from "@aura-frontend/omnibus-az-client";
import { toast } from "@win-reality/react-ui";
import { useState } from "react";

import { trackEvent } from "@/utils/trackEvent";

export function useGenerateReport() {
  const [generatingReportGameIds, setGeneratingReportGameIds] = useState<
    Set<string>
  >(new Set());

  const generateReport = async (
    game: Game,
    ageGroup: AgeGroup,
  ): Promise<boolean> => {
    const gameId = game.gameUuid;
    if (!gameId) {
      toast("Unable to generate report: missing game id.", {
        variant: "error",
      });
      return false;
    }
    setGeneratingReportGameIds((prev) => new Set(prev).add(gameId));
    try {
      const result = await postGameByGameIdReport({
        path: {
          game_id: gameId,
        },
        body: {
          ageGroup,
        },
        throwOnError: true,
      });
      if (result.response.ok) {
        trackEvent("report_generated", { gameId, ageGroup });
        toast(
          "Report generation started. You will receive an email when it's ready",
          {
            variant: "success",
          },
        );
        return true;
      }
      toast("Failed to generate report. Please try again.", {
        variant: "error",
      });
      return false;
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Failed to generate report. Please try again.";
      toast(errorMessage, {
        variant: "error",
      });
      return false;
    } finally {
      setGeneratingReportGameIds((prev) => {
        const next = new Set(prev);
        next.delete(gameId);
        return next;
      });
    }
  };

  return { generateReport, generatingReportGameIds };
}
